import React, { useEffect, useState } from 'react';

const SECTIONS = [
  { id: 'writing', label: 'Writing' },
  { id: 'reading', label: 'Reading' },
  { id: 'photos', label: 'Photos' },
];

// New York time, HH:MM:SS.
const fmt = new Intl.DateTimeFormat('en-US', {
  timeZone: 'America/New_York', hour12: false, hour: '2-digit', minute: '2-digit', second: '2-digit',
});

function Top({ page }) {
  const [now, setNow] = useState(() => new Date());
  const [fx, setFx] = useState(() => localStorage.getItem('crt-fx') !== 'off');

  useEffect(() => {
    const timer = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  // The CRT scanline overlay; preference survives reloads.
  useEffect(() => {
    document.body.classList.toggle('no-fx', !fx);
    localStorage.setItem('crt-fx', fx ? 'on' : 'off');
  }, [fx]);

  return (
    <header className="top">
      <div className="top-id">
        <a className="top-name" href="#about">Nico Pei</a>
        <span className="top-clock" aria-label="Time in New York">
          NYC <time>{fmt.format(now).replace(/^24/, '00')}</time>
        </span>
        <button
          className="fx-toggle"
          onClick={() => setFx(!fx)}
          aria-pressed={fx}
          title="Toggle CRT scanlines"
        >
          CRT: {fx ? 'ON' : 'OFF'}
        </button>
      </div>
      <nav className="top-nav" aria-label="Sections">
        {SECTIONS.map((s) => (
          <a key={s.id} href={`#${s.id}`} aria-current={page === s.id ? 'page' : undefined}>{s.label}</a>
        ))}
      </nav>
    </header>
  );
}

export default Top;
